export const questions: Array<[string, string]> = [
  [
    'How do I receive my collection after purchase?',
    "You'll receive instant access via email so you can start using it immediately — no waiting, no delays.",
  ],
  [
    'What educational level is this designed for?',
    "The material works for secondary schools, technical institutions, vocational training, and university programs. All 9 volumes let you adapt the level to your students' needs.",
  ],
  [
    'Does this work for international educators?',
    'Yes. The collection is updated for 2026 and works globally. It includes examples from around the world with guidance for adapting content to your specific regional context and water systems.',
  ],
  [
    'Are the materials editable?',
    'Yes. You receive all PDFs in editable format so you can customize them with your name, institution, or local water examples.',
  ],
  [
    'What currency do I pay in?',
    'You pay in USD (United States dollars). Your payment platform automatically shows the conversion to your local currency.',
  ],
  [
    'What makes this collection different from other materials?',
    "This isn't a random collection of activities. It's a complete system: 9 coherent volumes, 5 strategic bonuses, structured calculation exercises, ready-made assessments, and 50 integrated projects. Everything designed so you never improvise again.",
  ],
  [
    "What if I'm not satisfied?",
    'You have 7 days to review everything. If you feel it\'s not what you expected or doesn\'t provide value, request a refund and we return 100% with no questions.',
  ],
];
